import { Tab } from '../../../../../modals/modifier/ModifierModal';

export default {
  title: 'New modifier',
  tabs: {
    [Tab.General]: 'General',
    [Tab.NutritionInfo]: 'Nutrition info',
  },
  form: {
    modifier_groups: {
      label: 'Belongs to modifier groups',
    },
    name: {
      label: 'Name',
      placeholder: 'Ketchup',
    },
    external_id: {
      label: '{{integration}} ref',
      placeholder: 'e.g. HubRise SKU reference',
      read_only_hint: 'Editable only while a HubRise integration is connected and menu sync is turned off.',
    },
    price: {
      label: 'Base price',
      placeholder: 'Optional',
    },
    is_available: {
      label: 'In stock',
    },
    is_visible: {
      label: 'Visible',
      title: 'Visible on menu',
      subtitle_on: 'Customers can see this option',
      subtitle_off: 'Hidden from all customers',
    },
    is_available_for_pickup: {
      label: 'Available for pickup',
      subtitle_on: 'Customers can order it for pickup',
      subtitle_off: 'Hidden from pickup menu',
    },
    is_available_for_delivery: {
      label: 'Available for delivery',
      subtitle_on: 'Customers can order it for delivery',
      subtitle_off: 'Hidden from delivery menu',
    },
  },
  availability: {
    title: 'Availability',
    helper:
      'Visibility is the master switch. Turn off a channel to hide this option from pickup or delivery customers without removing it from the menu.',
    status: {
      both: 'Both channels',
      pickup_only: 'Pickup only',
      delivery_only: 'Delivery only',
      hidden: 'Hidden',
      no_channels: 'No channels',
    },
    warning: {
      no_channels: "This option is visible but available on no channels — customers won't be able to select it.",
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Pickup only',
      delivery_only: 'Delivery only',
      no_channels: 'No channels',
    },
  },
  buttons: {
    save: 'Save',
  },
  toasts: {
    changes_got_saved: 'Changes saved successfully!',
  },
};
